<script>
  import {createEventDispatcher} from 'svelte';

  const dispatch = createEventDispatcher();

  let className = '';

  export {className as class};
  /**
   * @type {number | string}
   */
  export let group = '';
  /**
   * @type {number | string}
   */
  export let value = '';
  export let disabled = false;
</script>

<style>
  i {
    color: #0d4fff;
  }
  .disabled {
    opacity: 0.7;
  }
</style>

<label class:active={group === value} class="f14 T2 cp {className}" class:disabled>
  <input class="dn" type="radio" bind:group {value} {disabled} on:input={v => dispatch('change', v)} />
  {#if group === value}
    <i class="iconfont">&#xe621;</i>
  {:else}
    <i class="iconfont">&#xe622;</i>
  {/if}
  <slot />
</label>
